export default {
  namespaced: true,

  state: {
    adBlockEnabled: false,
    apiStatusOk: false,
    isLoggedIn: false,
    hasTenant: false,
    hasAms1: false,
    hasAms2: false,
    deployingEnvironment: false,
    deployingNewTeam: false,
    pageLoading: true,
    showCards: false,
    showSubSidebar: false,
    showSidebar: false,
    animateCredit: false,
    showCredits: false,
    showHelpbar: false,
    activeHelpTab: false,
    changelog: [],
    currentChangelog: false,
    notifications: [],
    newNotification: false,
    is_beta_user: false,
    activeRegion: false,
    ticketSubject: false,
    userBlocked: false,
    newsArticles: false,
    emk: false,
    objectStore: false,
    cloud: true,
    updateDetailData: 0,
    updateListData: 0,
  },

  mutations: {
    SET_ACTIVE_REGION(state, value) {
      state.activeRegion = value;
    },

    SET_ADBLOCK_STATUS(state, bool) {
      state.adBlockEnabled = bool;
    },

    SET_API_STATUS(state, bool) {
      state.apiStatusOk = bool;
    },

    CHANGE_LOGGED_IN_STATE(state, bool) {
      state.isLoggedIn = bool;
    },

    HAS_TENANT(state, bool) {
      state.hasTenant = bool;
    },

    HAS_AMS1(state, bool) {
      state.hasAms1 = bool;
    },

    HAS_AMS2(state, bool) {
      state.hasAms2 = bool;
    },

    DEPLOYING_ENVIRONMENT(state, bool) {
      state.deployingEnvironment = bool;
    },

    DEPLOYING_NEW_TEAM(state, bool) {
      state.deployingNewTeam = bool;
    },

    PAGE_LOADING(state, bool) {
      state.pageLoading = bool;
    },

    IS_BETA_USER(state, bool) {
      state.is_beta_user = bool;
    },

    SHOW_CARDS(state, bool) {
      state.showCards = bool;
    },

    SHOW_SUB_SIDEBAR(state, bool) {
      state.showSubSidebar = bool;
    },

    SHOW_SIDEBAR(state, bool) {
      state.showSidebar = bool;
    },

    ANIMATE_CREDIT(state, bool) {
      state.animateCredit = bool;
    },

    SHOW_CREDITS(state, bool) {
      state.showCredits = bool;
    },

    CHANGELOG_DATA(state, data) {
      state.changelog = data;
    },

    SET_CURRENT_NOTIFICATION(state, log) {
      state.currentChangelog = log;
    },

    SHOW_HELPBAR(state, value) {
      state.showHelpbar = value;
    },

    ACTIVE_HELPBAR(state, value) {
      state.activeHelpTab = value;
    },

    NEW_NOTIFICATION(state, value) {
      state.newNotification = value;
    },

    SET_NOTIFICATIONS(state, value) {
      state.notifications.unshift(value);
      if (state.notifications.length > 8) {
          state.notifications.splice(-1,1)
      }
    },

    SET_TICKET_SUBJECT(state, data) {
      state.ticketSubject = data;
    },

    SET_BLOCKED_USER(state, data) {
      state.userBlocked = data;
    },

    SET_NEWS(state, data) {
      state.newsArticles = data;
    },

    SET_EMK(state, data) {
      state.emk = data;
    },

    SET_OBJECTSTORE(state, data) {
      state.objectStore = data;
    },

    SET_CLOUD(state, data) {
      state.cloud = data;
    },

    UPDATE_DETAIL_DATA(state) {
      state.updateDetailData += 1;
    },

    UPDATE_LIST_DATA(state) {
      state.updateListData += 1;
    },
  },

  actions: {
    SET_CURRENT(context, instance) {
      context.commit('SET_CURRENT', instance);
    },
  },
}
